define.alias("shared/components/shared/mavely/links/select-modal", "calendar/components/shared/mavely/links/select-modal");